import { jsx } from "react/jsx-runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import { Position, Toaster, Intent, Classes } from "@blueprintjs/core";
import classNames from "classnames";
const createToasterInstance = (props) => {
  const container = document.createElement("div");
  document.body.appendChild(container);
  const root = createRoot(container);
  let instance;
  root.render(/* @__PURE__ */ jsx(Toaster, { ...props, ref: (ref) => instance = ref }));
  return {
    show: (props2, key) => instance ? instance.show(props2, key) : console.warn("Toaster not ready"),
    dismiss: (key) => instance ? instance.dismiss(key) : null,
    clear: () => instance ? instance.clear() : null
  };
};
const TopToaster = createToasterInstance({
  className: "top-toaster",
  position: Position.TOP
});
const BottomToaster = createToasterInstance({
  className: "bottom-toaster",
  position: Position.BOTTOM
});
window.__tgClearAllToasts = () => {
  TopToaster.clear();
  BottomToaster.clear();
};
let counter = 5e3;
const generateToast = (intent) => (message, options) => {
  options = options || {};
  const toastToUse = options.bottom ? BottomToaster : TopToaster;
  let updatedTimeout;
  if (options.updateTimeout) {
    if (counter > 5500) {
      updatedTimeout = --counter;
    } else {
      updatedTimeout = ++counter;
    }
  }
  const maybeAddClearAll = () => {
    const existingClearAllButtons = document.querySelectorAll(`.tg-clear-all-toasts`);
    existingClearAllButtons.forEach((button) => {
      button.remove();
    });
    const activeToasts = document.querySelectorAll(
      `.bp3-toast:not(.bp3-toast-exit)`
    );
    if (activeToasts.length > 1) {
      const topToaster = document.querySelector(`.bp3-toast`);
      if (!topToaster) return;
      const closeButton = document.createElement("div");
      closeButton.classList.add(
        Classes.BUTTON,
        Classes.LARGE,
        Classes.INTENT_PRIMARY,
        "tg-clear-all-toasts"
      );
      closeButton.innerText = "Clear all";
      closeButton.onclick = window.__tgClearAllToasts;
      closeButton.style.position = "absolute";
      closeButton.style.right = "-100px";
      topToaster.appendChild(closeButton);
    }
  };
  const uniqKey = toastToUse.show(
    {
      intent,
      message,
      onDismiss: () => {
        if (options.onDismiss) {
          options.onDismiss();
        }
        setTimeout(() => {
          maybeAddClearAll();
        }, 0);
      },
      timeout: options.timeout || updatedTimeout || (!window.Cypress && (intent === Intent.DANGER || intent === Intent.WARNING) ? 6e4 : void 0),
      action: options.action,
      icon: options.icon,
      className: classNames("preserve-newline", options.className)
    },
    options.key
  );
  setTimeout(() => {
    maybeAddClearAll();
  }, 0);
  function clear() {
    toastToUse.dismiss(uniqKey);
    setTimeout(() => {
      maybeAddClearAll();
    }, 0);
  }
  clear.key = uniqKey;
  return clear;
};
function preventDuplicates(func) {
  const previousToasts = {};
  return (message, options = {}) => {
    const clearToast = func(message, options);
    if (!options.key) {
      if (!options.key && previousToasts[message]) {
        previousToasts[message]();
      }
      setTimeout(() => {
        delete previousToasts[message];
      }, options.timeout || 5e3);
      previousToasts[message] = clearToast;
    }
    return clearToast;
  };
}
if (!window.toastr) window.toastr = {};
if (!window.toastr.success) {
  window.toastr.success = preventDuplicates(generateToast(Intent.SUCCESS));
}
if (!window.toastr.error) {
  window.toastr.error = preventDuplicates(generateToast(Intent.DANGER));
}
if (!window.toastr.warning) {
  window.toastr.warning = preventDuplicates(generateToast(Intent.WARNING));
}
if (!window.toastr.info) {
  window.toastr.info = preventDuplicates(generateToast(Intent.PRIMARY));
}
if (!window.toastr.default) {
  window.toastr.default = preventDuplicates(generateToast(Intent.NONE));
}
